import { useEffect } from 'react'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import Checkbox from '@jimmyboys/liita-ui/dist/components/Checkbox'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'
import React, { useState } from 'react'

import { useHistory, Link } from 'react-router-dom'

import { ReactComponent as LoginBg } from '../../assets/images/login-bg.svg'
import { ReactComponent as Logo } from '../../assets/images/logo.svg'

import useSession from '../../hooks/useSession'
import styles from './LoginReset.module.sass'

const APP_VERSION = window.REACT_APP_VERSION || process.env.REACT_APP_VERSION

const Login = () => {
	const [inputState, setInputState] = useState({ username: '', password: '' })
	const [rememberMe, setRememberMe] = useState(true)
	const { user, activity, error, login } = useSession()
	const history = useHistory()
	const [queryParams] = useQueryParams()

	useEffect(() => {
		if (user && !user.changePasswordRequired) {
			history.push(queryParams.redirect || '/')
		} else if (user && user.changePasswordRequired) {
			history.push('/change-password')
		}
	}, [user, history, queryParams.redirect])

	// TODO: If user, prompt confirm to logout session or continue

	const handleSubmit = (e) => {
		e.preventDefault()
		if (!activity) {
			login(inputState.username, inputState.password, rememberMe)
		}
	}

	const handleInputChange = (e) => {
		const target = e.target
		setInputState((prevState) => ({
			...prevState,
			[target.name]: target.value,
		}))
	}

	return (
		<>
			<Logo className={styles['logo']} />
			<HStack
				className={styles['main']}
				columns={[1, 1]}
				justify='stretch'
			>
				<VStack align='center' justify='space-around'>
					<Widget
						className={styles['banner']}
						paddings={{
							small: ['normal', 'normal'],
							default: ['xlarge', 'large', ''],
						}}
					>
						<h1>
							Nós somos <strong>Trust!</strong>
						</h1>
						<p>
							<strong>Gestão Integrada de Saúde</strong>
						</p>
						<p>
							Terá de realizar login para continuar. Se pretende
							obter qualquer informação, por favor,{' '}
							<a href='mailto:trust@trustsaude.pt'>
								contacte-nos.
							</a>
						</p>
					</Widget>
					<LoginBg className={styles['illustration']} />
				</VStack>
				<VStack
					align='center'
					justify='center'
					className={styles['right-side']}
				>
					<div
						className={`${styles['form-container']} ${
							error ? styles['shake'] : ''
						}`}
					>
						<form onSubmit={handleSubmit} disabled={activity}>
							<h1>Bem-vindo</h1>
							<div className={styles['text-inputs']}>
								{error && (
									<div className={styles['message']}>
										<small>{error.message}</small>
									</div>
								)}
								{activity && (
									<div className={styles['message']}>
										<small>Logging In</small>
									</div>
								)}
								<TextInput
									autoComplete='username'
									tint='light'
									className={styles['text-input']}
									type='text'
									name='username'
									placeholder='username'
									required
									value={inputState.username}
									onChange={handleInputChange}
								/>
								<TextInput
									autoComplete='current-password'
									tint='light'
									className={styles['text-input']}
									type='password'
									name='password'
									placeholder='password'
									required
									value={inputState.password}
									onChange={handleInputChange}
								/>
							</div>
							<div className={styles['form-actions']}>
								<ActionButton
									className={styles['login-button']}
									primary
									type='submit'
								>
									Sign In
								</ActionButton>
							</div>
						</form>
						<div className={styles['extra-actions']}>
							<Checkbox
								tint='light'
								className={styles['checkbox']}
								label={'Remember me?'}
								checked={rememberMe}
								onChange={() => {
									setRememberMe(!rememberMe)
								}}
							/>
							<Link to='/forgot-password'>
								<small>Forgot password?</small>
							</Link>
						</div>
					</div>
				</VStack>
			</HStack>
			<small className={styles['version']}>{APP_VERSION}</small>
		</>
	)
}

export default Login
